import { IProfile } from 'interfaces/users'
import api from '..'

export interface ICertificateCourse {
  id: number
  name: string
  color?: string
  lmsProfiles?: IProfile[]
}

export interface ICertificateCoursesSummary {
  allowedCourses: ICertificateCourse[]
  restrictedCoursesCount: number
  total: number
}

export const getAssociatedCourses = (
  certificateId: number | string,
  { page, search, perPage }: { page: number; search: string; perPage?: number }
): Promise<{ data: ICertificateCoursesSummary }> => {
  return api.get(`/certificates/${certificateId}/associated_courses`, {
    params: {
      page,
      search,
      per_page: perPage,
    },
  })
}

export const getAdminAssociatedCourses = (
  certificateId: number | string,
  { page, search, perPage }: { page: number; search: string; perPage?: number }
): Promise<{ data: ICertificateCoursesSummary }> => {
  return api.get(
    `/administration/certificates/${certificateId}/associated_courses`,
    {
      params: {
        page,
        search,
        per_page: perPage,
      },
    }
  )
}
